module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av195-c31f4b9970493fb9bdca3b58d3456075.jpg";